module.exports = __webpack_public_path__ + "assets/img/mailRouting.d15c21c3.png";